export default "__VITE_ASSET__COEdgPje__"